import { WordDetailPage } from "@/features/learning-content/pages/WordDetail";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const WordDetail: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <WordDetailPage />
      </Box>
    </Stack>
  );
};

export default WordDetail;
